var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15530_3814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.305 10.2304C20.305 9.55059 20.2499 8.86714 20.1323 8.19839H10.7V12.0492H16.1015C15.8773 13.2912 15.1571 14.3898 14.1026 15.088V17.5866H17.325C19.2174 15.8449 20.305 13.2728 20.305 10.2304Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 20.0007C13.397 20.0007 15.6715 19.1151 17.3287 17.5866L14.1062 15.0879C13.2096 15.6979 12.0522 16.0433 10.7037 16.0433C8.0948 16.0433 5.88279 14.2832 5.08911 11.9169H1.76373V14.4927C3.46133 17.8695 6.91898 20.0007 10.7 20.0007Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08546 11.9169C4.66657 10.675 4.66657 9.33011 5.08546 8.08814V5.51236H1.76376C0.345428 8.33801 0.345428 11.6671 1.76376 14.4927L5.08546 11.9169Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 3.95805C12.1257 3.936 13.5036 4.47247 14.5361 5.45722L17.3911 2.60218C15.5833 0.904587 13.1839 -0.0287217 10.7 0.000673888C6.91898 0.000673888 3.46133 2.13185 1.76373 5.51234L5.08543 8.08812C5.87544 5.71811 8.09113 3.95805 10.7 3.95805Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15530_3814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.03b363850e463150e104fcfec422ba5b.svg";
export { ForwardRef as ReactComponent };